import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  GetUserStats200,
  GetUserStats401,
  GetUserStats404,
  GetUserStats500
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * @summary 사용자 통계 정보 조회
 */
export const getUserStats = (
    userId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserStats200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/users/${userId}/stats`,options
    );
  }


export const getGetUserStatsQueryKey = (userId: string,) => {
    return [`https://api.ugot.uk/api/users/${userId}/stats`] as const;
    }

    
export const getGetUserStatsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getUserStats>>, TError = AxiosError<GetUserStats401 | GetUserStats404 | GetUserStats500>>(userId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserStats>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserStatsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserStats>>> = ({ signal }) => getUserStats(userId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(userId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserStatsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getUserStats>>>
export type GetUserStatsInfiniteQueryError = AxiosError<GetUserStats401 | GetUserStats404 | GetUserStats500>

/**
 * @summary 사용자 통계 정보 조회
 */
export const useGetUserStatsInfinite = <TData = Awaited<ReturnType<typeof getUserStats>>, TError = AxiosError<GetUserStats401 | GetUserStats404 | GetUserStats500>>(
 userId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserStats>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserStatsInfiniteQueryOptions(userId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetUserStatsQueryOptions = <TData = Awaited<ReturnType<typeof getUserStats>>, TError = AxiosError<GetUserStats401 | GetUserStats404 | GetUserStats500>>(userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserStats>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserStatsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserStats>>> = ({ signal }) => getUserStats(userId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(userId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserStats>>>
export type GetUserStatsQueryError = AxiosError<GetUserStats401 | GetUserStats404 | GetUserStats500>

/**
 * @summary 사용자 통계 정보 조회
 */
export const useGetUserStats = <TData = Awaited<ReturnType<typeof getUserStats>>, TError = AxiosError<GetUserStats401 | GetUserStats404 | GetUserStats500>>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserStats>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserStatsQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



